import { render, staticRenderFns } from "./WorldContactForm.vue?vue&type=template&id=b113ded6&scoped=true&"
import script from "./WorldContactForm.vue?vue&type=script&lang=js&"
export * from "./WorldContactForm.vue?vue&type=script&lang=js&"
import style0 from "./WorldContactForm.vue?vue&type=style&index=0&id=b113ded6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b113ded6",
  null
  
)

export default component.exports